import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=b59c43c6&"
import script from "./Create.vue?vue&type=script&lang=babel&"
export * from "./Create.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports